import { Component, Input } from '@angular/core';
import { UtilsService } from '../shared/utils.service';
import { Router } from '@angular/router';

@Component({
    selector: 'admin-menu',
    template: require('./partials/admin-menu.component.html')
})
export class AdminMenuComponent {
    @Input() currentLanguage: string;

    constructor(public utils: UtilsService) {}

} 




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-menu.component.ts